import { BRAND } from "@/lib/brand";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0B1B3D] text-white pt-20 pb-10 relative overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="h-12 w-12 rounded-xl overflow-hidden bg-white p-1.5">
                <img src={BRAND.logo} alt="Akshar" className="w-full h-full object-contain" />
              </div>
              <div>
                <div className="font-display text-2xl font-semibold">
                  Akshar <span className="text-[#10B981]">Investments</span>
                </div>
                <div className="overline text-[10px] text-white/50">{BRAND.tagline}</div>
              </div>
            </div>
            <p className="mt-6 text-white/65 leading-relaxed max-w-md">
              An AMFI Registered Mutual Fund Distributor and IRDAI Licensed Insurance Agent based in
              Navsari, Gujarat. Helping Indian families compound capital since 2024.
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {["AMFI Registered", "IRDAI Licensed", "QPFP Certified", "NISM V-A & X-A"].map((b) => (
                <span
                  key={b}
                  className="text-[10px] uppercase tracking-[0.18em] font-bold px-3 py-1.5 rounded-full bg-white/10 border border-white/15"
                >
                  {b}
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-sm font-medium text-[#10B981] mb-5">Navigate</div>
            <ul className="space-y-3 text-sm text-white/75">
              <li><a href="#about" className="hover:text-[#10B981]">About</a></li>
              <li><a href="#goals" className="hover:text-[#10B981]">Goals</a></li>
              <li><a href="#services" className="hover:text-[#10B981]">Services</a></li>
              <li><a href="#testimonials" className="hover:text-[#10B981]">Reviews</a></li>
              <li><a href="#contact" className="hover:text-[#10B981]">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-sm font-medium text-[#10B981] mb-5">Reach us</div>
            <ul className="space-y-4 text-sm text-white/80">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[#10B981] flex-shrink-0" />
                <span className="leading-relaxed">{BRAND.address}</span>
              </li>
              <li>
                <a href={BRAND.phoneHref} className="flex items-center gap-3 hover:text-[#10B981]">
                  <Phone className="w-4 h-4 text-[#10B981]" />
                  {BRAND.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${BRAND.email}`} className="flex items-center gap-3 hover:text-[#10B981]">
                  <Mail className="w-4 h-4 text-[#10B981]" />
                  {BRAND.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="my-12 h-px bg-white/10" />

        <div className="grid md:grid-cols-2 gap-6 text-xs text-white/45 leading-relaxed">
          <p>
            © {new Date().getFullYear()} Akshar Investments. All rights reserved. Founded by{" "}
            {BRAND.owner}.
          </p>
          <p className="md:text-right">
            Mutual fund investments are subject to market risks. Read all scheme-related documents
            carefully before investing.
          </p>
        </div>

        {/* Outsized brand watermark */}
        <div className="mt-14 -mb-10 pointer-events-none select-none">
          <div className="font-display text-[22vw] leading-none font-light text-white/[0.03] tracking-tight whitespace-nowrap">
            akshar
          </div>
        </div>
      </div>
    </footer>
  );
}
